<template>
  <nav class="breadcrumbs">
    <ol
      class="breadcrumbs-list"
      itemscope itemtype="http://schema.org/BreadcrumbList"
    >
      <li
        itemprop="itemListElement"
        itemscope itemtype="http://schema.org/ListItem"
        v-for="(breadcrumb, i) in breadcrumbs"
        v-bind:key="breadcrumb.path"
      >
        <router-link
          itemprop="item"
          itemscope itemtype="http://schema.org/Thing"
          v-bind:itemid="breadcrumb.path"
          v-bind:to="breadcrumb.path"
          v-bind:title="(breadcrumb.path === '/') ? 'На главную' : null"
          v-if="i < breadcrumbs.length - 1"
        >
          <font-awesome-icon
            v-if="breadcrumb.path === '/'"
            v-bind:icon="homeIcon"
          ></font-awesome-icon
          ><span itemprop="name">{{ breadcrumb.text }}</span>
        </router-link>
        <span
          itemprop="item"
          itemscope itemtype="http://schema.org/Thing"
          v-bind:itemid="breadcrumb.path"
          v-else
        >
          <span itemprop="name">{{ breadcrumb.text }}</span>
        </span>
        <meta itemprop="position" v-bind:content="i + 1">
      </li>
    </ol>
  </nav>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'Breadcrumbs',
  props: {
    'names': { // a map: alias -> name
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: { FontAwesomeIcon },
  data: function () {
    return {
      homeIcon: faHome,
      navigation: [],
      breadcrumbs: []
    }
  },
  watch: {
    $route (to, from) {
      if (to.path !== from.path) {
        this.buildBreadcrumbs()
      }
    }
  },
  mounted () {
    this.$http
      .get(`${process.env.API_HOST}/api/v1/site-structure/get-menu`)
      .then(response => {
        this.navigation = response.body
        this.buildBreadcrumbs()
      })
  },
  methods: {
    buildBreadcrumbs: function () {
      let breadcrumbs = this.buildAliasedBreadcrumbs()
      breadcrumbs = this.replaceAliasesWithNames(breadcrumbs)
      this.breadcrumbs = breadcrumbs
    },
    buildAliasedBreadcrumbs: function () {
      // $route.path is an absolute path, like /catalog/rings
      let pathParts = this.$route.path.split('/')
      if (this.$route.path === '/') {
        pathParts = pathParts.slice(0, 1)
      }

      const nonBreadcrumbParts = this.getNonBreadcrumbParts()
      let breadcrumbs = []
      for (let i = 0; i < pathParts.length; i++) {
        if (!nonBreadcrumbParts.includes(pathParts[i])) {
          breadcrumbs.push({
            text: pathParts[i],
            path: pathParts.slice(0, i + 1).join('/')
          })
        }
      }
      breadcrumbs[0].path = '/'
      return breadcrumbs
    },
    replaceAliasesWithNames: function (breadcrumbs) {
      // $route.path is an absolute path, like /catalog/rings
      let pathParts = this.$route.path.split('/')

      breadcrumbs[0].text = 'Главная'

      let categories = this.navigation
      let i = 1
      for (i = 1; i < breadcrumbs.length; i++) {
        let category = categories.find(function (item) {
          return item.alias === pathParts[i]
        })
        if (!category) { break }
        breadcrumbs[i].text = category.short_name

        categories = category.categories
        if (!categories) { break }
      }
      for (let j = i; j < breadcrumbs.length; j++) {
        // try to find the names not mentioned in the navigation
        // in a map of names that was passed as a component param
        if (pathParts[j] in this.names) {
          breadcrumbs[j].text = this.names[pathParts[j]]
        }
      }
      return breadcrumbs
    },
    getNonBreadcrumbParts: function () {
      let nonBreadcrumbParts = this.$route.meta.nonBreadcrumbParts || []

      nonBreadcrumbParts = nonBreadcrumbParts.map(function (p) {
        return (p[0] === ':') ? this.$route.params[p.slice(1)] : p
      }, this)
      nonBreadcrumbParts = nonBreadcrumbParts.filter(p => p !== undefined)
      nonBreadcrumbParts = nonBreadcrumbParts.map(p => p.toString())
      return nonBreadcrumbParts
    }
  }
}
</script>

<style scoped lang="scss">
  .breadcrumbs {
    @media only print {
      display: none;
    }
    .breadcrumbs-list {
      line-height: 1.75em;
      list-style-type: none;
      padding: 0;
      margin: 0;

      & > li {
        display: inline-block;
        margin: 0;
        & > a, span {
          font-family: "Gotham Pro Regular", $font-stack;
        }
        & > a {
          color: $default-heading-color;
          text-decoration: none;
          &:hover { color: $active-link-color; }
        }
        &:first-child {
          & > a > span {
            display: none;
          }
        }
        &:last-child {
          font-weight: bold;
        }
        &:not(:last-child):after {
          content: "/";
          padding: 0 0.85em 0 0.75em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/Breadcrumbs.vue